import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { uploadExcelFile } from "../../../services/Societe";
import makeAnimated from "react-select/animated";
import { useLocation } from 'react-router-dom';
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import api from "../../../services/api";
import WarehouseService from "../../../services/WarehouseService";
import { Snackbar } from "@mui/material";
import { Alert } from "@material-ui/lab";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import withLoader from "../../../components/layouts/WithLoader";
const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const UploadExcelStockSell = ({ startLoading, stopLoading }) => {
  const [uploadedData, setUploadedData] = useState(null); // Track file
  const [isUploading, setIsUploading] = useState(false); // Track upload state
  const [selectedOption, setSelectedOption] = useState(null);
  const [warehouseSourceId, setWarehouseSourceId] = useState(null);
  const [errorAlertText, setErrorAlertText] = useState();
  const [allWarehouseSource, setAllWarehouseSource] = useState([{}]);
  const [notAdded, setNotAdded] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [warehousesSource, setWarehousesSource] = useState([]);
  const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
    useState("Choisir...");
  const onChangeSelectedWarehouseSource = (selectedOptionn) => {
    setSelectedOption();
    setWarehouseSourceId(selectedOptionn.value);
    setWarehouseSelectPlaceHolder(selectedOptionn.label);
  };

  // Function to download the model Excel
  const onTelechargerModel = () => {
    const headers = [
      ["code à barre", "qte"], // Header row
      // ["Value1", "Value2", "Value3"],   // Example row of data
    ];
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(headers);

    // Add green background styling to headers
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = {
        fill: { fgColor: { rgb: "00FF00" } }, // Green background
        font: { bold: true, color: { rgb: "000000" } }, // Black bold text
      };
    }

    // Append worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Model");

    // Save file as a downloadable Excel file
    const fileBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([fileBuffer], { type: "application/octet-stream" }), "model.xlsx");
  };

  // Handle file upload
  const handleFileUpload = (e) => {
    const file = e.target.files[0]; // Get the first file from the input
    if (file) {
      setUploadedData(file); // Store the file in state
    }
  };
  useEffect(() => {
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        if (response.data.success) {
          setWarehousesSource(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      });
  }, []);
  useEffect(() => {
    warehousesSource &&
      warehousesSource.map((element) => {
        let exist = false;
        if (allWarehouseSource.length !== 0) {
          for (let index = 0; index < allWarehouseSource.length; index++) {
            if (allWarehouseSource[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseSource((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
        //here
      });
  }, [warehousesSource]);
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  // Upload the Excel file to the server
  const uploadExcelFileToServer = (file) => {
    if (!file) {
      toast.error("Aucun fichier sélectionné");
      return Promise.reject(new Error("No file provided"));
    }
  
    if (!warehouseSourceId) {
      toast.error("ID de l'entrepôt source manquant");
      return Promise.reject(new Error("Missing warehouseSourceId"));
    }
  
    const stockType = sessionStorage.getItem("stockType");
    if (!["Min", "Max"].includes(stockType)) {
      toast.error("Type de stock invalide");
      return Promise.reject(new Error("Invalid stockType"));
    }
  
    const formData = new FormData();
    formData.append("file", file);
  
    const url = stockType === "Min"
      ? `/retail/warehouse/updateStock/addStockMinToProductStockByExcel/${getCurrentUserId()}/${warehouseSourceId}`
      : `/retail/warehouse/updateStock/addStockMaxToProductStockByExcel/${getCurrentUserId()}/${warehouseSourceId}`;
  
    startLoading();
  
    return api
      .put(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      })
      .then((response) => {
        toast.success("Fichier téléchargé avec succès");
        return response;
      })
      .catch((error) => {
        toast.error("Erreur lors du téléchargement du fichier");
        throw error;
      })
      .finally(() => {
        stopLoading();
      });
  };
  

  const animatedComponents = makeAnimated();
  // Handle adding the uploaded file
  const handleAjouter = () => {
    if (uploadedData && !isUploading) {
      setIsUploading(true); // Set uploading state to true
      uploadExcelFileToServer(uploadedData)
        .then((response) => {
          console.log("Upload successful", response);
          setNotAdded(response.data["not addedd"]);
        })
        .catch((error) => {
          console.error("Upload error", error);
        })
        .finally(() => {
          setIsUploading(false); // Reset uploading state after process finishes
        });
    } else {
      console.error("No file selected for upload or upload already in progress.");
    }
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <ToastContainer />
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">Home</li>
                <li className="breadcrumb-item active">Les stocks {sessionStorage.getItem("stockType")}</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-footer">
                  <h3>Ajouter les stocks {sessionStorage.getItem("stockType")}</h3>
                </div>
                <div className="p-3 d-flex justify-content-between align-items-center">
                  <h4>Télécharger le Model Excel</h4>
                  <button className="btn btn-dark float-right" onClick={onTelechargerModel}>
                    <i className="fas fa-download"></i> Télécharger model Excel
                  </button>
                </div>
                <div className="card-body my-0 py-0">
                  <p>Si la valeur de la colonne n'est pas présente merci de mettre -</p>
                </div>
                <div class="card-body mt-0 pt-0">
                  <div className="row">
                    {/* First Column */}
                    <div className="col-md-6 d-flex flex-column">
                      <div className="form-group">
                        <label>Choisir le dépôt</label>
                        <div className="input-group" style={{ flexGrow: 1 }}>
                          <div className="input-group-prepend" style={{ width: "100%" }}>
                            <Select
                              styles={styles}
                              closeMenuOnSelect={true}
                              components={animatedComponents}
                              onChange={onChangeSelectedWarehouseSource}
                              options={allWarehouseSource}
                              placeholder={warehouseSelectPlaceHolder}
                            />
                          </div>
                          <Snackbar
                            open={openErrorAlert}
                            autoHideDuration={4000}
                            onClose={handleEroorClose}
                            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                          >
                            <Alert onClose={handleEroorClose} severity="error">
                              {errorAlertText}
                            </Alert>
                          </Snackbar>
                        </div>
                      </div>
                    </div>

                    {/* Second Column */}
                    <div className="col-md-6 d-flex mt-1 pt-2">
                      <div
                        className="p-3 d-flex justify-content-between align-items-center flex-grow-1"
                        style={{ flexGrow: 1 }}
                      >
                        <input
                          style={{
                            border: "1px solid hsl(0, 0%, 80%)",
                            width: "100%"
                          }}
                          type="file"
                          accept=".xlsx, .xls"
                          className="btn float-right"
                          onChange={handleFileUpload} // Handle file selection
                        />
                      </div>
                    </div>
                  </div>


                </div>

                <div className="card-footer">
                  <div className="p-3 d-flex justify-content-end align-items-center">

                    <button
                      className="btn btn-dark float-end"
                      onClick={handleAjouter} // Upload file
                      title="Ajouter cette liste"
                      aria-label="Ajouter cette liste"
                      disabled={isUploading} // Disable button while uploading
                    >
                      <i className="fas fa-location-arrow" aria-hidden="true"></i> Ajouter cette liste
                    </button>
                  </div>
                </div>

              </div>
              {notAdded && notAdded.length > 0 && (
                <div className="card-footer">
                  <div className="p-3 ">
                    <h4>Liste des produits non ajoutés</h4>
                    <div className=" my-0 py-0">
                      <p>{notAdded.join(', ')}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default withLoader(UploadExcelStockSell);
